import { Grid } from '@mui/material';
import { Text, SizeableRoundedDialog, PrimaryButton } from 'library';
import React from 'react';

export default function DocumentDownloadInfo({
    showDocDownloadInfo,
    setShowDocDownloadInfo,
}: {
    showDocDownloadInfo: boolean;
    setShowDocDownloadInfo: (show: boolean) => void;
}) {
    return (
        <SizeableRoundedDialog
            open={showDocDownloadInfo}
            onClose={() => setShowDocDownloadInfo(false)}
            contentStyle={{ padding: 40, maxWidth: 600 }}
            closeButton={true}
        >
            <Grid container direction="column" spacing={2}>
                <Grid item>
                    <Text variant="h1">Heads up!</Text>
                </Grid>
                <Grid item>
                    <Text>
                        It looks like this worker is new to your site! You&apos;ll find a completed 718-B-DC in this
                        worker&apos;s document file. To receive clearance for this worker to work in your program,
                        you&apos;ll need to file the attached 718-B-DC form with DCFS as soon as possible. Tandem
                        provides you with the documentation you need — but it is the center&apos;s responsibility to
                        file the 718-B-DC.
                    </Text>
                </Grid>
                <PrimaryButton
                    buttonStyle={{ maxWidth: 200, alignSelf: 'flex-end' }}
                    onClick={() => setShowDocDownloadInfo(false)}
                >
                    Close
                </PrimaryButton>
            </Grid>
        </SizeableRoundedDialog>
    );
}
